// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /contest/reopen-preview-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeContestReopenPreviewGetBody,
  typeContestReopenPreviewGetOutput200,
} from "../../sdk/contest/postContestReopenPreviewGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildContestReopenPreviewGetQueryKey(
  payload: typeContestReopenPreviewGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`contestId:${JSON.stringify(payload.contestId)}`);
  return [
    "post:contest:contestReopenPreviewGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeContestReopenPreviewGetOutput200,
    unknown,
    typeContestReopenPreviewGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useContestReopenPreviewGet(
  payload: typeContestReopenPreviewGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildContestReopenPreviewGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postContestReopenPreviewGet(payload),
    ...resolvedOptions,
  });
}
